import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Input } from 'reactstrap';

const MIN_SEARCH_LENGTH = 2;

export class Autocomplete extends Component {
	static propTypes = {
		options: PropTypes.instanceOf(Array).isRequired,
	};
	state = {
		activeOption: 0,
		filteredOptions: [],
		showOptions: false,
		userInput: '',
		open: false,
	};

	onChange = (e) => {
		const { options, onSearch } = this.props;
		const userInput = e.currentTarget.value;
		const trimmedInput = String(userInput).trim().toLowerCase();

		// Server mode: dropdown is driven by props.options.
		const filteredOptions = onSearch
			? options
			: options.filter(
					(optionName) =>
						String(optionName).trim().toLowerCase().indexOf(trimmedInput) > -1
			  );

		this.setState({
			activeOption: 0,
			filteredOptions,
			showOptions: trimmedInput.length >= MIN_SEARCH_LENGTH,
			userInput,
		});

		// Trigger server search.
		if (onSearch) {
			onSearch(userInput);
		}

		this.props.setFieldValue('companyName', userInput);
		const toLowerCaseOptions = options.map((opt) => String(opt).toLowerCase());
		if (!toLowerCaseOptions.includes(trimmedInput)) {
			this.props.setCustomCompany(userInput);
		} else {
			this.props.setCustomCompany('');
		}
	};

	onClick = (e) => {
		this.setState({ clicked: true });
		this.setState({
			activeOption: 0,
			filteredOptions: [],
			showOptions: false,
			userInput: e.currentTarget.innerText,
		});
		let toLowerCaseOptions = this.props.options.map((opt) =>
			String(opt).toLowerCase()
		);
		this.props.setFieldValue('companyName', e.currentTarget.innerText);
		if (
			toLowerCaseOptions.includes(
				String(e.currentTarget.innerText).toLowerCase()
			)
		) {
			this.props.setCustomCompany('');
		} else {
			this.props.setCustomCompany(e.currentTarget.innerText);
		}
	};
	onKeyDown = (e) => {
		const { activeOption } = this.state;
		const list = this.getVisibleOptions();

		if (e.keyCode === 13) {
			this.setState({
				activeOption: 0,
				showOptions: false,
				userInput: list[activeOption],
			});
		} else if (e.keyCode === 38) {
			if (activeOption === 0) {
				return;
			}
			this.setState({ activeOption: activeOption - 1 });
		} else if (e.keyCode === 40) {
			if (activeOption === list.length - 1) {
				return;
			}
			this.setState({ activeOption: activeOption + 1 });
		}
	};

	// Options to display in the dropdown.
	getVisibleOptions = () => {
		return this.props.onSearch ? this.props.options : this.state.filteredOptions;
	};

	render() {
		const { onChange, onClick, onKeyDown } = this;
		const { showOptions, userInput } = this.state;
		const visibleOptions = this.getVisibleOptions();

		let optionList;
		if (
			showOptions &&
			userInput &&
			String(userInput).trim().length >= MIN_SEARCH_LENGTH &&
			visibleOptions.length
		) {
			optionList = (
				<div>
					<ul className='options'>
						{visibleOptions.map((optionName, index) => (
							<li
								key={index}
								onMouseDown={(e) => {
									e.preventDefault();
								}}
								onClick={(e) => {
									onClick(e);
								}}>
								{optionName}
							</li>
						))}
					</ul>
				</div>
			);
		}
		return (
			<div>
				<div className='search'>
					<Input
						id={this.props.id}
						type='text'
						placeholder='Search the company name'
						aria-label={this.props.ariaLabel}
						className='search-box'
						onChange={onChange}
						onKeyDown={onKeyDown}
						name={this.props.name}
						value={userInput}
						invalid={this.props.invalid}
						autoComplete='new-password'
						maxLength={2048}
						onBlur={() => {
							// Delay hide so an option click registers.
							setTimeout(() => this.setState({ showOptions: false }), 150);
						}}
					/>
				</div>
				{optionList}
			</div>
		);
	}
}

export default Autocomplete;
